// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const GenesisTheme = props => {
    useThemeStylesheet(() => import("./genesis.lazy.scss"));
    return <>
        <ContrastColorUpdater/>
        {props.children}
    </>;
};

export default GenesisTheme;
